import { render, staticRenderFns } from "./StatStrip.vue?vue&type=template&id=1070e3c1&scoped=true"
import script from "./StatStrip.vue?vue&type=script&lang=js"
export * from "./StatStrip.vue?vue&type=script&lang=js"
import style0 from "./StatStrip.vue?vue&type=style&index=0&id=1070e3c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070e3c1",
  null
  
)

export default component.exports